module.exports = "/img/_/_/_/assets/images/creeper/battle/common//24.jpg?5f98768dc7b8185a2999bfab372a6677";